import React from 'react';
import Icon from '../ui/Icon';

/**
 * Game Controls Component
 * Single Responsibility: Rendering game control buttons
 * Interface Segregation: Only handles control UI, not game logic
 */
const GameControls = ({ 
  currentLine, 
  moveIndex, 
  onPrevious, 
  onNext, 
  onHint, 
  onReset,
  onNextLine,
  hasNextLine = false,
  disabled = false
}) => {
  const totalMoves = currentLine?.moves?.length || 0;
  const isAtStart = !currentLine || moveIndex <= 0;
  const isComplete = !currentLine || moveIndex >= totalMoves;

  return (
    <div className="w-full flex items-center gap-2" style={{ maxWidth: 'min(calc(100vw - 24px), 760px)' }}>
      <button onClick={onPrevious} disabled={disabled || isAtStart} className="btn-secondary btn-icon" title="Previous move" aria-label="Previous move">
        <Icon name="chevronLeft" size={18} />
      </button>
      <button onClick={onReset} disabled={disabled} className="btn-secondary btn-icon" title="Restart the line" aria-label="Restart the line">
        <Icon name="rotate" size={17} />
      </button>

      <div className="flex-1 text-center text-xs font-semibold text-ink-400 tabular-nums">
        {currentLine ? `Move ${Math.min(moveIndex, totalMoves)} / ${totalMoves}` : ''}
      </div>

      {isComplete && hasNextLine ? (
        <button onClick={onNextLine} disabled={disabled} className="btn-primary" title="Continue to next line">
          Next line <Icon name="arrowRight" size={16} />
        </button>
      ) : (
        <button onClick={onHint} disabled={disabled || isComplete} className="btn-secondary" title={isComplete ? 'Line completed' : 'Show the next move'}>
          {isComplete ? <><Icon name="check" size={16} /> Done</> : <><Icon name="lightbulb" size={16} /> Hint</>}
        </button>
      )}
      <button onClick={onNext} disabled={disabled || isComplete} className="btn-secondary btn-icon" title="Next move" aria-label="Next move">
        <Icon name="chevronRight" size={18} />
      </button>
    </div>
  );
};

export default GameControls;
